import * as Constants from './constants'

const initialState = {
  list: [],
  listUser: [],
  listCmb: {},
  listKhachHangUser: [],
  listDvhc: [],
  item: {},
  dataErr: [],
  type: Constants.KHACHHANG_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  isPopupLoading: false,
  messages: [],
  errors: [],
  formData: {},
  listNhomKH: [],
  callback: function () { },
}

const reducer = function khachhangReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.KHACHHANG_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data || {},
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_CMB_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_CMB_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listCmb: action.data,
        item: action.data,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_CMB_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_USER_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_USER_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listUser: action.data.records,
        item: action.data,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_USER_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_USER_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
        listRequesting: true,
      }

    case Constants.KHACHHANG_USER_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data || {},
        listKhachHangUser: action.data.khachHangUser || [],
        messages: [],
        errors: [],
        listRequesting: false,
      }

    case Constants.KHACHHANG_USER_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        listRequesting: false,
      }
    case Constants.KHACHHANG_USER_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_USER_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_USER_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_UPLOAD_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isPopupLoading: true,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_UPLOAD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        dataErr: action.payload.data,
        type: action.type,
        isPopupLoading: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_UPLOAD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isPopupLoading: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_DVHC_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_DVHC_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listDvhc: action.data.records,
        item: action.data,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_DVHC_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_REMOVE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_REMOVE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_REMOVE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_SET_MESSAGE:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        messages: [{
          body: action.payload.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_SET_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        errors: [{
          body: action.payload.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_SET_REQUESTING:
      return {
        ...state,
        isRequesting: action.payload,
      }
    case Constants.KHACHHANG_NHOM_LIST_REQUESTING:
      return {
        ...state,
        type: action.type,
        messages: [],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_NHOM_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNhomKH: action.data,
        item: action.data,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_NHOM_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_TRATHUONG_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_TRATHUONG_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        successful: true,
        messages: [{
          body: "Trả điểm khách hàng thành công",
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_TRATHUONG_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        isRequesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_GET_CONFIG_REQUESTING:
      return {
        ...state,
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case Constants.KHACHHANG_GET_CONFIG_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data.data || 0,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_GET_CONFIG_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.KHACHHANG_LIST_DON_247_REQUESTING:
      return {
        ...state,
        isRequesting: true,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/KhachHang/reducer.js